<template>
  <div class="mt-base flex w-full vx-row no-gutter justify-center">
    <div class="vx-col w-full sm:w-full md:w-3/4 lg:w-2/3 xl:w-1/2 mx-8">
      <div class="flex w-full mb-base justify-center">
        <img
          src="@/assets/images/project/hexasense-logo.png"
          alt="logo"
          width="220px"
          height="100%"
        />
      </div>
      <vx-card class="px-10 py-4 mb-base">
        <span class="flex item-center justify-center mb-6">
          <span class="h4">{{ $t("contactForm.Title") }}</span>
        </span>
        <form>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <div class="mb-4">
                <label class="vs-input--label" for="first_name"
                  >{{ $t("contactForm.FirstName") }}:</label
                >
                <vs-input
                  v-validate="'required'"
                  name="first_name"
                  v-model="first_name"
                  class="w-full"
                  color="warning"
                  :placeholder="$t('contactForm.FirstName')"
                />
                <span
                  class="text-danger text-sm"
                  v-if="errors.has('first_name') && first_name == ''"
                  >{{ $t("form.ErrorMessages.Required") }}</span
                >
              </div>
              <div class="mb-4">
                <label class="vs-input--label" for="last_name"
                  >{{ $t("contactForm.LastName") }}:</label
                >
                <vs-input
                  v-validate="'required'"
                  name="last_name"
                  v-model="last_name"
                  class="w-full"
                  color="warning"
                  :placeholder="$t('contactForm.LastName')"
                />
                <span
                  class="text-danger text-sm"
                  v-if="errors.has('last_name') && last_name == ''"
                  >{{ $t("form.ErrorMessages.Required") }}</span
                >
              </div>
              <div class="mb-4">
                <label class="vs-input--label" for="email"
                  >{{ $t("contactForm.Email") }}:</label
                >
                <vs-input
                  v-validate="'required|email'"
                  name="email"
                  :placeholder="$t('contactForm.Email')"
                  v-model="email"
                  class="w-full"
                  color="warning"
                />
                <span class="text-danger text-sm" v-show="errors.has('email')">
                  <span v-if="email == ''">
                    {{ $t("login.FormMailEmpty") }}
                  </span>
                  <span v-else>
                    {{ $t("login.FormMailValid") }}
                  </span>
                </span>
              </div>
              <div class="mb-4">
                <label class="vs-input--label" for="description"
                  >{{ $t("contactForm.Description") }}:</label
                >
                <vs-textarea
                  v-validate="'required'"
                  name="description"
                  class="w-full mb-0 vs-textarea-200"
                  color="warning"
                  :placeholder="$t('contactForm.Description')"
                  v-model="description"
                />
                <span
                  class="text-danger text-sm"
                  v-if="errors.has('description') && description == ''"
                  >{{ $t("form.ErrorMessages.Required") }}</span
                >
              </div>
              <div class="mb-4">
                <vue-recaptcha
                  class="w-100"
                  :sitekey="sitekey"
                  :loadRecaptchaScript="true"
                  :language="lan"
                  @verify="onVerify"
                  @expired="onExpired"
                >
                </vue-recaptcha>
                <span
                  class="text-danger text-sm"
                  v-if="robot == false && submitted == true"
                  >{{ $t("form.ErrorMessages.Required") }}</span
                >
              </div>
            </div>

            <div class="vx-col w-full mt-4">
              <div class="text-center">
                <vs-button
                  class="w-full"
                  type="filled"
                  color="warning"
                  @click.prevent="submitForm"
                  >{{ $t("buttons.Send")
                  }}<feather-icon
                    class="ml-3 bx-spin"
                    :class="isSubmitFormLoading == true ? '' : 'd-none'"
                    icon="LoaderIcon"
                    svgClasses="w-5 h-5"
                  ></feather-icon
                ></vs-button>
              </div>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>
<script>
import i18n from '../../i18n/i18n.js'
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    VueRecaptcha
  },
  data () {
    return {
      first_name: '',
      last_name: '',
      email: '',
      description: '',
      robot: false,
      sitekey: process.env.VUE_APP_V2_SITE_KEY,
      lan: i18n.locale,
      isSubmitFormLoading: false,
      submitted: false,
      token: localStorage.getItem('token')
    }
  },
  methods: {
    onVerify (response) {
      if (response) this.robot = true
    },
    onExpired () {
      this.robot = false
    },
    submitForm () {
      this.$validator.validateAll().then((result) => {
        this.submitted = true
        if (this.robot === false) {
          return
        }
        if (result && this.robot === true) {
          this.isSubmitFormLoading = true
          const data = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            description: this.description
          }

          this.$store
            .dispatch('support', data)
            .then(() => {
              this.isSubmitFormLoading = false
              this.$vs.notify({
                title: i18n.t('notifyAlert.success.title'),
                text: i18n.t('contactForm.SuccessMessage'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success',
                position: 'top-right',
                time: 4000
              })
              this.$router.push(this.token ? '/hives' : '/login')
            })
            .catch((error) => {
              this.isSubmitFormLoading = false
              this.errorMsg(error)
            })
        }
      })
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.vs-input--label {
  font-size: 0.9rem !important;
  font-weight: 500 !important;
}
.height-300 {
  height: 300px;
}
</style>
<style lang="scss">
.vs-textarea-200.focusx {
  min-height: 200px !important;
}
.vs-textarea-200.vs-con-textarea .vs-textarea {
  min-height: 200px !important;
}
</style>